/* ============================================
   BeeLive Studio — bee-pcard-builder.js — 27/08/2026
   Source UNIQUE du HTML d'une carte produit (.bee-pcard) côté JavaScript.
   ⚠️ Doit rester identique au snippet Liquid bee-product-card.liquid.
   ============================================

   Utilisé par la section « BEE — Produits liés » (assets/bee-produits-lies.js)
   et par les suggestions du configurateur (assets/beelive-configurateur.js).

   ── 27/08/2026 ─────────────────────────────────────────────────────────
   Alignement sur bee-product-card.liquid après la suppression de la lightbox :
   ajout de .bee-pcard__img-link (surface de clic vers la fiche produit, lien
   vide en position absolue, pas une enveloppe : un <a> ne peut pas contenir
   les <button> des flèches photo) ; retrait de .bee-pcard__desc--full et de
   .bee-pcard__tags. ⚠️ Rien à voir avec data-profil / data-tags posés sur le
   wrapper, qui pilotent le filtre par profil.

   Les clés p.fullDescHtml et p.tags sont ignorées. Plus aucun appelant ne les
   passe depuis le 21/09/2026.
   ============================================ */
(function () {
  'use strict';

  const fmtPrice = n => parseFloat(n).toFixed(2).replace('.', ',');
  const esc = s => (s == null ? '' : String(s));
  const productUrl = h => ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'products/' + h;

  // p = { title, img, handle, shortDesc, tags, variants:[{id,title,price},...] }
  window.beeBuildPcard = function (p) {
    const vs = p.variants || [];
    const vA = vs[0] || {};
    const vP = vs[1] || vs[0] || {};
    const hasTwo = vs.length > 1;

    // Liste d'images : soit p.images (tableau), soit fallback sur p.img unique
    const imgList = (Array.isArray(p.images) && p.images.length ? p.images : (p.img ? [p.img] : []))
      .map(u => u.replace(/\.(jpg|png|gif|webp)/, '_400x.$1'));
    const hasMultiImg = imgList.length > 1;

    /* Surface de clic vers la fiche produit. Vide et transparente : le titre
       juste en dessous fournit déjà le libellé du lien, d'où tabindex="-1" et
       aria-hidden="true" — sans quoi clavier et lecteur d'écran annonceraient
       deux fois la même destination.
       Le CSS .bee-pcard__img-link (z-index 2) la place au-dessus de l'image et
       SOUS les flèches (z-index 3), qui restent cliquables. */
    const lienImg = p.handle
      ? `<a class="bee-pcard__img-link" href="${productUrl(esc(p.handle))}" tabindex="-1" aria-hidden="true"></a>`
      : '';

    const imgHtml = imgList.length
      ? `<img src="${imgList[0]}" alt="${esc(p.title)}" loading="lazy">`
        + lienImg
        + (hasMultiImg ? `
          <button class="bee-pcard__img-arrow bee-pcard__img-arrow--prev" type="button" aria-label="Image précédente"><svg aria-hidden="true"><use href="#bee-chevron-left"></use></svg></button>
          <button class="bee-pcard__img-arrow bee-pcard__img-arrow--next" type="button" aria-label="Image suivante"><svg aria-hidden="true"><use href="#bee-chevron-right"></use></svg></button>` : '')
      : `<div class="bee-pcard__img-inner">${esc(p.title).slice(0, 1).toUpperCase()}</div>` + lienImg;

    const fmtBlock = (v, format, active) => `
      <div class="bee-pcard__fmt${active ? ' bee-pcard__fmt--active' : ''}" data-format="${format}">
        <div class="bee-pcard__fmt-top">
          <span class="bee-pcard__fmt-name">${esc(v.title)}</span>
        </div>
        <span class="bee-pcard__fmt-price">${fmtPrice(v.price)} €<span class="ttc"> TTC</span></span>
      </div>`;

    return `
      <div class="bee-pcard"
        data-variant-adhesif="${vA.id}"
        data-variant-pvc="${vP.id}">
        <span class="bee-pcard__cart-badge" data-qty="0">Dans le panier</span>
        <div class="bee-pcard__img"${hasMultiImg ? ` data-images="${imgList.join('|')}" data-img-idx="0"` : ''}>${imgHtml}</div>
        <div class="bee-pcard__body">
          <h3 class="bee-pcard__name">${p.handle ? `<a href="${productUrl(esc(p.handle))}" class="bee-pcard__name-link">${esc(p.title)}</a>` : esc(p.title)}</h3>
          ${p.shortDesc ? `<div class="bee-pcard__desc bee-pcard__desc--short">${p.shortDesc}</div>` : ''}
        </div>
        <div class="bee-pcard__sep"></div>
        <div class="bee-pcard__formats">
          ${fmtBlock(vA, 'adhesif', !hasTwo)}
          ${hasTwo ? fmtBlock(vP, 'pvc', true) : ''}
        </div>
        <div class="bee-pcard__add-row">
          <div class="bee-pcard__qty">
            <button class="bee-pcard__qty-btn" data-dir="down" aria-label="Diminuer">−</button>
            <span class="bee-pcard__qty-val">1</span>
            <button class="bee-pcard__qty-btn" data-dir="up" aria-label="Augmenter">+</button>
          </div>
          <button class="bee-pcard__add-btn" type="button">Ajouter au panier</button>
        </div>
      </div>`;
  };
})();